import { hotjar } from 'react-hotjar';

const HOTJAR_NUMBER_ID = +import.meta.env.HOTJAR_ID;
const HOTJAR_VERSION = +import.meta.env?.HOTJAR_VERSION;

export const initHotjar = () => {
    HOTJAR_NUMBER_ID && hotjar.initialize(HOTJAR_NUMBER_ID, HOTJAR_VERSION);
};
